// extracted by mini-css-extract-plugin
module.exports = {"root":"header_root__XFs07","navbar_brand":"header_navbar_brand__1YzKa","logo":"header_logo__RH02A"};